import { useMemo } from 'react';

import { buildRackGrid, flattenGrid, computeSummaryStats } from '../utils';

import type { WorkOrderDetailViewModel } from '@api/enterprise/openapi/models';
import type { RackCell, RackStats } from '../types';

type UseRackGridReturn = {
  grid: RackCell[][];
  flatCells: RackCell[];
  stats: RackStats;
};

export const useRackGrid = (
  details: WorkOrderDetailViewModel[]
): UseRackGridReturn => {
  const { grid, flatCells, stats } = useMemo(() => {
    const g = buildRackGrid(details);
    const f = flattenGrid(g);
    const s = computeSummaryStats(f);
    return { grid: g, flatCells: f, stats: s };
  }, [details]);

  return { grid, flatCells, stats };
};
